import react, { useState } from 'react';
import { Button } from 'antd';
import DailyAddErpModal from './components/daily-add-erp-modal';

export default function BtnPowerManage({ roomId }) {
  const [visible, setVisible] = useState(false);
  function powerManage() {
    setVisible(true);
  }
  return (
    <>
      <Button shape="round" onClick={powerManage} ghost type="primary">
        权限管理
      </Button>
      <DailyAddErpModal visible={visible} setVisible={setVisible} roomId={roomId} />
    </>
  );
}
